
'use client'
import React, { useState } from 'react';
import styles from './style.module.scss';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { menuSlide } from '../anim';
// import Link from './Link';
// import Curve from './Curve';
// import Footer from './Footer';

import { BurgerLink } from './link/burger-link';
import { Curve } from './curve/curve';
import { navData } from '@/constants';

const navItems = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'Work',
    href: '/work',
  },
  {
    title: 'About',
    href: '/about',
  },
  {
    title: 'Contact',
    href: '/contact',
  },
];

export const BurgerMenu = () => {
  const pathname = usePathname();
  const [selectedIndicator, setSelectedIndicator] = useState(pathname);

  return (
    <motion.div
      variants={menuSlide}
      initial="initial"
      animate="enter"
      exit="exit"
      className={styles.menu}>
      <div className={styles.body}>
        <div
          onMouseLeave={() => {
            setSelectedIndicator(pathname);
          }}
          className={styles.nav}>
       
          {navData.map((data, index) => {
            return (
              <BurgerLink
                key={index}
                data={{ ...data, index }}
                isActive={selectedIndicator == data.link}
                //@ts-ignore
                setSelectedIndicator={setSelectedIndicator}/>
            );
          })}
        </div>
      </div>
      <Curve />
    </motion.div>
  );
}
